import React from 'react';
import './landing-card.scss';

export default ({ className, children }) => {
    return (
        <div className={`landing-card ${className ? className : ''}`}>
            {children}
        </div>
    )
}
